import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS } from './tokens';

export default function NumberedStep({ index, children, size = 28, fontSize = { xs: 15, md: 16 } }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
            <Box
                sx={{
                    width: size,
                    height: size,
                    borderRadius: '50%',
                    backgroundColor: COLORS.green,
                    color: '#fff',
                    flex: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    fontSize: size >= 28 ? 14 : 13
                }}
            >
                {index}
            </Box>
            <Typography sx={{ fontSize, lineHeight: 1.4, pt: 0.375 }}>{children}</Typography>
        </Box>
    );
}
